import { mensagemDeErro } from '@common/errors/mensagemDeErro';
import { useToast } from '@ntconsult/aluma-react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { escritasAxiisQueries } from '../queries';
import { escritasAxiisService } from '../services/escritasAxiisService';

export function useEscritasAxiis(id: string) {
  return useQuery(escritasAxiisQueries.resumo(id));
}

/** Retenta as escritas pendentes/com falha da campanha e mostra o toast do resultado. */
export function useRetentarEscritas(id: string) {
  const qc = useQueryClient();
  const { t } = useTranslation(['escritas', 'erros']);
  const { toast } = useToast();
  const mutation = useMutation({
    mutationFn: () => escritasAxiisService.retentar(id),
    onSettled: () => qc.invalidateQueries({ queryKey: escritasAxiisQueries.resumo(id).queryKey }),
  });

  async function retentar() {
    try {
      const r = await mutation.mutateAsync();
      const title = t('escritas:resultado', { count: r.sucesso, falha: r.falha });
      if (r.falha > 0) toast.warning({ title });
      else toast.success({ title });
    } catch (error) {
      toast.danger({ title: t(`erros:${mensagemDeErro(error)}`) });
    }
  }

  return { retentar, isPending: mutation.isPending };
}
